import createMessages from 'mz-intl/create'

export default createMessages('TRIP_LIST', {
  OLD_CONFIRMATION_NUMBER: 'Old: {number}',
  NEW_CONFIRMATION_NUMBER: 'New: {number}',
})
